import { Box } from "@mui/material";
import {
  CheckCircle,
  Cancel,
  WarningAmber,
  HelpOutline,
} from "@mui/icons-material";

const getEstadoStyles = (
  estadoId: "success" | "warning" | "wrong" | "unknown"
) => {
  switch (estadoId) {
    case "wrong":
      return { bgColor: "#F8D7DA", color: "#721C24", Icon: Cancel }; // rojo pastel
    case "warning":
      return { bgColor: "#FFF3CD", color: "#856404", Icon: WarningAmber }; // amarillo pastel
    case "success":
      return { bgColor: "#D4EDDA", color: "#155724", Icon: CheckCircle }; // verde pastel
    default:
      return { bgColor: "#E2E3E5", color: "#383D41", Icon: HelpOutline }; // gris pastel
  }
};

interface EstadoBadgeProps {
  estado: "success" | "warning" | "wrong" | "unknown";
  children?: React.ReactNode;
}

const EstadoBadge: React.FC<EstadoBadgeProps> = ({ estado, children }) => {
  const { bgColor, color, Icon } = getEstadoStyles(estado);

  if (children) {
    return (
      <Box
        sx={{
          backgroundColor: bgColor,
          color: color,
          px: 1.5,
          py: 0.5,
          borderRadius: "7px",
          fontSize: "0.75rem",
          display: "inline-block",
          minWidth: "75px",
          textAlign: "center",
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: 26,
        height: 26,
        borderRadius: "7px",
        backgroundColor: bgColor,
        color,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1.1rem",
      }}
    >
      <Icon sx={{ fontSize: 18 }} />
    </Box>
  );
};

export default EstadoBadge;

// Lógica para mapear el estado
export const getEstadoFromUser = (user?: {
  enabled?: boolean;
  isActive?: boolean;
}) => {
  if (!user) return "wrong"; // no existe

  // Si cualquiera de las dos propiedades está definida y es false → inactivo
  if (user.enabled === false || user.isActive === false) return "warning";

  return "success"; // activo
};
